import React, { Component } from 'react'
import { Card, CardTitle } from 'react-toolbox/lib/card'
import { Flex, Box } from 'reflexbox'
import CSSModules from 'helpers/CSSModulesUtil'
import { IconButton } from 'react-toolbox/lib/button'
import FulcrumDivider from 'components/fulcrum/divider/Divider'
import Collapse from 'components/fulcrum/collapse/Collapse'
import {
  compose,
} from 'recompose'

import styles from './styles.scss'

const Header = ({ title, collapse, onCollapseToggle, onRefresh }) => (
  <Flex align='center'>
    <h5 className={styles.headerTitle}>{title}</h5>
    <Flex
      auto
      justify='flex-end'
      align='center'>
      <Box>
        {onRefresh ? <IconButton icon={'cached'} onClick={onRefresh} /> : null}
        <IconButton icon={!collapse ? 'expand_more' : 'expand_less'} onClick={onCollapseToggle} />
      </Box>
    </Flex>
  </Flex>
)

const CollapsableCard = ({ inCollapse, outCollapse, title, collapse, onCollapseToggle, onRefresh }) => (
  <Card theme={styles}>
    <div styleName='header'>
      <Header title={title} collapse={collapse} onCollapseToggle={onCollapseToggle} onRefresh={onRefresh} />
    </div>
    <FulcrumDivider styleName='divider' />
    <div styleName='body'>
      {outCollapse}
      <Collapse collapse={collapse}>
        {inCollapse}
      </Collapse>
    </div>
  </Card>
)

const withStyles = CSSModules(styles)

export default compose(withStyles)(CollapsableCard) 